import TYPES from '../../types';

// Domain
import { ProofOfAddressDto } from '../../domain/dtos/proof-of-address-dto';
import { StateManager } from '../../domain/state/state-manager';
import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';

@Injectable()
export default class ProofOfAddressService {
  @Inject(TYPES.CUSTOMER_ADDRESS_STATE_MANAGER)
  private readonly state_manager!: StateManager;

  setProofOfAddressFileData(address_proof: File | null): void {
    this.state_manager.state.proof_of_address_file = address_proof;
  }

  getProofOfAddressFileData(): File | null {
    return this.state_manager.state.proof_of_address_file;
  }

  setProofOfAddressData(address_proof: ProofOfAddressDto): void {
    this.state_manager.state.proof_of_address = { ...address_proof };
  }

  getProofOfAddressData(): ProofOfAddressDto {
    return this.state_manager.state.proof_of_address;
  }
}
